/*
 * @Author: cryi.liu
 * @Date: 2020-05-13 10:07:23
 * @LastEditTime: 2020-09-11 15:32:32
 * @Description: 试题库数据仓库
 */
export default {
  namespaced: true,

  state: {
    // 筛选条件
    filters: {
      years: [], // 年份
      productGroupCodes: [], //  产品组
      productCodes: [], // 型号简称
      types: [], // 题库类型
      content: '', // 题目内容
      questionTypes: [], // 题目类型
      levels: [], //   题目难易度
    },
    // 多选删除题目id列表
    deleteIds: [],
  },

  getters: {
    // 获取试题库筛选条件
    filters({ filters }) {
      return filters;
    },
    // 获取年份筛选条件
    yearsFilter({ filters: { years } }) {
      return years;
    },
    // 获取产品组筛选条件
    productGroupCodesFilter({ filters: { productGroupCodes } }) {
      return productGroupCodes;
    },
    // 获取型号名称筛选条件
    productCodesFilter({ filters: { productCodes } }) {
      return productCodes;
    },
    // 获取题库类型筛选条件
    typesFilter({ filters: { types } }) {
      return types;
    },
    // 获取题目内容筛选条件
    contentFilter({ filters: { content } }) {
      return content;
    },
    // 获取题目类型筛选条件
    questionTypesFilter({ filters: { questionTypes } }) {
      return questionTypes;
    },
    // 获取题目难易度筛选条件
    levelFilter({ filters: { levels } }) {
      return levels;
    },
    // 获取多选删除题目id列表
    deleteIds({ deleteIds }) {
      return deleteIds;
    },
  },

  mutations: {
    // 重置筛选条件
    resetFilters(state) {
      state.filters.years = [];
      state.filters.productGroupCodes = [];
      state.filters.productCodes = [];
      state.filters.types = [];
      state.filters.content = '';
      state.deleteIds = [];
    },
    // 设置年份筛选条件
    setYearsFilter(state, { years }) {
      state.filters.years = years;
    },
    // 设置产品组筛选条件
    setProductGroupCodesFilter(state, { productGroupCodes }) {
      state.filters.productGroupCodes = productGroupCodes;
    },
    // 设置型号名称筛选条件
    setProductCodesFilter(state, { productCodes }) {
      state.filters.productCodes = productCodes;
    },
    // 设置题库类型筛选条件
    setTypesFilter(state, { types }) {
      state.filters.types = types;
    },
    // 设置题目内容筛选条件
    setContentFilter(state, { content }) {
      state.filters.content = content;
    },
    // 设置题目类型筛选条件
    setQuestionTypesFilter(state, { questionTypes }) {
      state.filters.questionTypes = questionTypes;
    },
    // 设置题目难易度筛选条件
    setLevelsFilter(state, { levels }) {
      state.filters.levels = levels;
    },
    // 设置多选删除题目id列表
    setDeleteIds(state, { deleteIds }) {
      state.deleteIds = deleteIds;
    },
  },

  actions: {
    invokeResetFilters({ commit }) {
      commit('resetFilters');
    },
    invokeSetYearsFilter({ commit }, payload) {
      commit('setYearsFilter', payload);
    },
    invokeSetProductGroupCodesFilter({ commit }, payload) {
      commit('setProductGroupCodesFilter', payload);
    },
    invokeSetProductCodesFilter({ commit }, payload) {
      commit('setProductCodesFilter', payload);
    },
    invokeSetTypesFilter({ commit }, payload) {
      commit('setTypesFilter', payload);
    },
    invokeSetContentFilter({ commit }, payload) {
      commit('setContentFilter', payload);
    },
    invokeSetQuestionTypesFilter({ commit }, payload) {
      commit('setQuestionTypesFilter', payload);
    },
    invokeSetLevelsFilter({ commit }, payload) {
      commit('setLevelsFilter', payload);
    },
    invokeSetDeleteIds({ commit }, payload) {
      commit('setDeleteIds', payload);
    },
  },
};
